import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Alert } from 'react-bootstrap';
import { TableHeaderColumn } from 'react-bootstrap-table';
import * as moment from 'moment';
import { get, sortBy, isEmpty } from 'lodash';
import flatten from 'flat';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import InternalContainer from '../../layout/containers/Internal';
import getIncludedResource from '../../../helpers/getIncludedResource';
import {
  Box,
  Button,
  DataTable,
  SimpleHorizontalFormControl,
} from '../../../common/components';
import { applyFilter } from '../../../common/components/DataTable/redux/dataTableActions';
import DatePickerDobMasked from '../../../common/components/DatePicker/DatePickerDobMasked';
import validate from './validate';
import { hasPermission, isBroker, isOwner } from '../../auth/redux/authActions';
import { actions } from '../redux/dashboardActions';
import {
  storeCustomerSearch,
  clearCustomerSearch,
} from './searchActions/storeCustomerSearch';
import ButtonBar from '../../../common/components/ButtonBar/ButtonBar';
import './Dashboard.scss';
import formatDate from '../../../helpers/formatDate';
import { bindActionCreators, compose } from 'redux';
import NewCustomer from '../components/NewCustomer/NewCustomer';

const isValidDate = (value) => {
  const formattedDate = moment(value, 'DD/MM/YYYY').utcOffset(0, true);
  if (!isEmpty(value)) {
    return !formattedDate.isValid() || isEmpty(value)
      ? 'Please enter a valid date'
      : null;
  }
};
const LEISURE_TRAVEL = 'Leisure Travel';

class DashboardContainer extends Component {
  constructor(props) {
    super(props);
    this.handleSearchButton = this.handleSearchButton.bind(this);
    this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
    this.handleNameUpdate = this.handleNameUpdate.bind(this);
    this.handleLastNameUpdate = this.handleLastNameUpdate.bind(this);
    this.handleEmailUpdate = this.handleEmailUpdate.bind(this);
    this.handleDOBUpdate = this.handleDOBUpdate.bind(this);
    this.handlePostcodeUpdate = this.handlePostcodeUpdate.bind(this);
    this.handleNewQuoteButton = this.handleNewQuoteButton.bind(this);
    this.handleNewQuoteSearch = this.handleNewQuoteSearch.bind(this);
    this.getProductIdByName = this.getProductIdByName.bind(this);
    this.state = {
      alertVisible: true,
      showTable: false,
      initTableFilters: [],
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(clearCustomerSearch());
  }

  componentWillMount() {
    const { dashboard, actions } = this.props;
    if (!dashboard.lastUpdated) {
      actions.fetchStats();
    } else {
      const now = moment();
      if (now.diff(dashboard.lastUpdated, 'minutes') > 10) {
        actions.fetchStats();
      }
    }
  }

  handleAlertDismiss() {
    this.setState({
      alertVisible: false,
    });
  }

  handleNameUpdate(event) {
    this.props.dispatch(
      applyFilter('customers', 'filter[name.first_name]', event.target.value),
    );
  }

  handleLastNameUpdate(event) {
    this.props.dispatch(
      applyFilter('customers', 'filter[name.last_name]', event.target.value),
    );
  }

  handleEmailUpdate(event) {
    this.props.dispatch(applyFilter('customers', 'filter[email]', event.target.value));
  }

  handleDOBUpdate(event) {
    const formattedDate = moment(event.target.value, 'DD/MM/YYYY').utcOffset(0, true);
    if (formattedDate.isValid()) {
      this.props.dispatch(
        applyFilter('customers', 'filter[dob]', formattedDate.format()),
      );
    } else {
      this.props.dispatch(applyFilter('customers', 'filter[dob]', ''));
    }
  }

  handlePostcodeUpdate(event) {
    this.props.dispatch(
      applyFilter('customers', 'filter[address.postcode]', event.target.value),
    );
  }

  handleSearchButton() {
    const { formValues } = this.props;
    const filters =
      formValues &&
      Object.keys(formValues.metadata).map((key) => {
        const filter = formValues.metadata[key];
        if (key === 'first_name' || key === 'last_name') {
          return { type: 'filter[name.' + key + ']', value: filter };
        }
        if (key === 'dob') {
          const formattedDate = moment(filter, 'DD/MM/YYYY')
            .utcOffset(0, true)
            .format();
          if (formattedDate !== 'Invalid Date') {
            return { type: 'filter[' + key + ']', value: formattedDate };
          }
        }
        if (key === 'email') {
          return { type: 'filter[' + key + ']', value: filter };
        }
        if (key === 'address') {
          return { type: 'filter[address.postcode]', value: filter['postcode'] };
        }
      });
    this.setState({
      showTable: true,
      initTableFilters: filters,
    });
  }

  handleNewQuoteSearch() {
    const { dispatch, formValues } = this.props;
    dispatch(storeCustomerSearch(formValues));
    dispatch(push('products/' + this.getProductIdByName(LEISURE_TRAVEL) + '/quote'));
  }

  getProductIdByName(productName) {
    const products = sortBy(
      getIncludedResource(
        this.props.auth.user.data,
        this.props.auth.user.included,
        'available_products',
      ),
      'attributes.name',
    );
    let productId = 'Unknown';

    products.map((product) => {
      if (product.attributes.name === productName) {
        productId = product.id;
      }
    });

    return productId;
  }

  handleNewQuoteButton(product) {
    const { dispatch } = this.props;
    dispatch(clearCustomerSearch());
    //dispatch(push('products/' + this.getProductIdByName(LEISURE_TRAVEL) + '/quote'));
    const productId = product.id;
    dispatch(push('products/' + productId + '/quote'));
  }

  handleRowClick(row) {
    this.props.dispatch(push(`/customers/${row.id}`));
  }

  render() {
    const {
      auth,
      handleSubmit,
      error,
      submitFailed,
      submitSucceeded,
      dashboard,
    } = this.props;
    const { initTableFilters } = this.state;
    const formErrors = error && error instanceof Object ? flatten(error) : false;
    const productsSortedByName = sortBy(
      getIncludedResource(auth.user.data, auth.user.included, 'available_products'),
      'attributes.name',
    );
    // Push Travel product to top of list.
    let productsWithoutTravel = productsSortedByName.filter(
      (product) => product.attributes.product_code !== 'TRAV',
    );
    let travelProduct = productsSortedByName.filter(
      (product) => product.attributes.product_code === 'TRAV',
    );
    const products = travelProduct.concat(productsWithoutTravel);

    const statsPoliciesDay = get(dashboard, 'stats.meta.day.quotes.issued', '');
    const statsQuotesDay = get(dashboard, 'stats.meta.day.quotes.unconverted', '');
    const upper = (value) =>
      value &&
      value.replace(/^(.)|(\s|-)(.)/g, (letter) => {
        return letter.toUpperCase();
      });

    if (!get(auth.user, 'data.relationships.current_organisation')) {
      return <div>Sort it out</div>;
    }
    const formatAddress = (cell, row) => {
      return row.address.postcode;
    };

    const isTransactingUser = isOwner() || isBroker();

    return (
      <InternalContainer
        hideBreadcrumbs
        title={'Welcome Back, ' + auth.user.data.attributes.first_name + '!'}
      >
        <div>
          <div className="form-horizontal">
            <div
              className={
                isTransactingUser
                  ? 'col-sm-6 internal-container'
                  : 'col-sm-12 internal-container'
              }
            >
              <div className="dashboard-width-100 get-quotes-header">
                <h3> {isTransactingUser && 'Existing '}Customer </h3>
              </div>
              <Box className="quotes-box adjust-height" minHeight>
                <div className={'dashboard-new-customer--text'}>
                  Check to see if your customer has issued a quote or policy with us
                  before.
                </div>
                <form
                  onSubmit={handleSubmit(this.handleSearchButton)}
                  style={{ paddingTop: 30 }}
                >
                  <div className="form-group">
                    <div className="col-md-3">
                      <label className="control-label">First Name</label>
                    </div>
                    <div className="col-md-8">
                      <Field
                        name="metadata.first_name"
                        type="text"
                        component={SimpleHorizontalFormControl}
                        placeholder="First Name"
                        onChange={this.handleNameUpdate}
                        normalize={upper}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="col-md-3">
                      <label className="control-label">Surname</label>
                    </div>
                    <div className="col-md-8">
                      <Field
                        name="metadata.last_name"
                        type="text"
                        component={SimpleHorizontalFormControl}
                        placeholder="Surname"
                        normalize={upper}
                        onChange={this.handleLastNameUpdate}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="col-md-3">
                      <label className="control-label">Email</label>
                    </div>
                    <div className="col-md-8">
                      <Field
                        name="metadata.email"
                        type="email"
                        component={SimpleHorizontalFormControl}
                        placeholder="Email"
                        onChange={this.handleEmailUpdate}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="col-md-3">
                      <label className="control-label">Postcode</label>
                    </div>
                    <div className="col-md-8">
                      <Field
                        name="metadata.address.postcode"
                        type="text"
                        component={SimpleHorizontalFormControl}
                        placeholder="Postcode"
                        onChange={this.handlePostcodeUpdate}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="col-md-3">
                      <label className="control-label">Date of Birth</label>
                    </div>
                    <div className="col-md-4">
                      <Field
                        name="metadata.dob"
                        type="text"
                        showYear
                        maxDate={moment().format()}
                        component={DatePickerDobMasked}
                        placeholder="dob"
                        onChange={this.handleDOBUpdate}
                        validate={isValidDate}
                      />
                    </div>

                    <div className="col-md-offset-1 col-md-3">
                      <Button
                        type="submit"
                        className="pull-right pad-top btn-padding"
                        label={<span className="placeholder"> Search</span>}
                        bsStyle="primary"
                        search
                      />
                    </div>
                  </div>
                </form>
                {(submitFailed || submitSucceeded) &&
                formErrors &&
                this.state.alertVisible === true ? (
                  <div className="search-has-error">
                    <Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
                      Please complete at least 1 piece of information.
                    </Alert>
                  </div>
                ) : (
                  <div />
                )}
                {submitSucceeded && (
                  <div
                    className={
                      !submitSucceeded || formErrors
                        ? 'table-hidden'
                        : 'search-customer-box'
                    }
                  >
                    <DataTable
                      source="/local/customers"
                      name="customers"
                      showTotal
                      autoFilters={initTableFilters}
                      onRowSelect={this.handleRowClick.bind(this)}
                      pageOff
                      customHeight={!submitSucceeded ? '5px' : ''}
                      style={{ minHeight: '5px' }}
                    >
                      <TableHeaderColumn dataField="id" isKey hidden />
                      <TableHeaderColumn dataField="first_name">
                        First Name
                      </TableHeaderColumn>
                      <TableHeaderColumn dataField="last_name">Surname</TableHeaderColumn>
                      <TableHeaderColumn dataField="dob" dataFormat={formatDate}>
                        Date of Birth
                      </TableHeaderColumn>
                      <TableHeaderColumn dataField="email" dataSort>
                        Email
                      </TableHeaderColumn>
                      <TableHeaderColumn dataField="address" dataFormat={formatAddress}>
                        Postcode
                      </TableHeaderColumn>
                    </DataTable>
                    {isTransactingUser && (
                      <ButtonBar>
                        <div className="pull-right pad-top">
                          <span className="customer-title">
                            Not an existing customer?
                          </span>
                          <Button
                            label={'Create a new Quote'}
                            bsStyle={'primary'}
                            handleClick={() => this.handleNewQuoteSearch()}
                          />
                        </div>
                      </ButtonBar>
                    )}
                  </div>
                )}
              </Box>
            </div>

            <div className="col-sm-6 internal-container">
              {hasPermission('policy.quote') && (
                <NewCustomer
                  handleNewQuoteButton={this.handleNewQuoteButton}
                  products={products}
                />
              )}
              {hasPermission('dashboard.ticker_view') && (
                <div className="box-quotes-today">
                  <div className="quotes-today">
                    Quotes Today
                    <div className="result-today-quotes">{statsQuotesDay}</div>
                  </div>
                  <div className="policy-today">
                    Policies Today
                    <div className="result-today-policy">{statsPoliciesDay}</div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </InternalContainer>
    );
  }
}

const FORM_NAME = 'DashboardContainer';
const selector = formValueSelector(FORM_NAME);
export default compose(
  connect(
    (state, props) => ({
      auth: state.auth,
      dashboard: state.dashboard,
      initialValues: props.resource,
      formValues: selector(state, 'data', 'metadata'),
    }),
    (dispatch) => ({
      actions: bindActionCreators(actions, dispatch),
    }),
  ),
  reduxForm({ form: FORM_NAME, validate }),
)(DashboardContainer);
